var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStructureIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 758,
    height: 375,
    viewBox: "0 0 758 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.125 65.6027L460.555 138.902L461.876 270.704L436.625 265.114L267.729 305.375V224.93L234.262 216.638L207.109 229.495V243.918L144.398 268.649L129.725 267.185L123.957 268.195L40.876 254.945L149.157 171.905L410.879 240.323V183.196L325.095 153.799L640.441 0.632324L639.125 65.6027Z",
    fill: "#6C8637",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.189 126.105V165.953L639.126 65.6027L640.442 0.632324L757.189 126.105Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.879 183.197V240.323L149.156 171.905V93.5215L325.095 153.8L410.879 183.197Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.157 93.5215V171.905L40.876 254.945V208.437L149.157 93.5215Z",
    fill: "#8CAA4F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.644 334.186V358.483L437.001 315.132L436.624 265.115L461.875 270.704L524.54 284.577L575.47 295.848L603.444 302.045L678.885 318.748L748.644 334.186Z",
    fill: "#CBF07F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.002 315.131L123.967 363.552V339.647L129.725 338.27L144.398 334.772L207.109 319.823L234.262 313.351L267.729 305.375L436.625 265.114L437.002 315.131Z",
    fill: "#8CAA4F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.966 339.648V363.552L122.941 363.71L63.7129 361.41V335.578L123.955 339.648H123.966Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7134 335.578V361.41L62.0814 361.344L1.22168 374.375V355.713L63.7134 335.578Z",
    fill: "#8CAA4F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.541 169.262V284.576L461.876 270.704L460.555 138.901L524.541 169.262Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.188 165.952V194.075L678.886 210.094L603.445 159.945L575.471 168.88L524.541 185.154V169.262L460.555 138.901L639.125 65.6025L757.188 165.952Z",
    fill: "#5C752B",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.883 210.095V318.748L603.442 302.045V159.946L678.883 210.095Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.724 267.185V338.27L123.966 339.647H123.956V268.194L129.724 267.185Z",
    fill: "#8CAA4F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.398 268.649V334.772L129.725 338.271V267.185L144.398 268.649Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.472 168.879V295.847L524.542 284.576V185.154L575.472 168.879Z",
    fill: "#6C8637",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.444 159.946V302.045L575.47 295.849V168.881L603.444 159.946Z",
    fill: "#6C8637",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.612 225.048V305.492L234.146 313.468V216.755L267.612 225.048Z",
    fill: "#ABCD67",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.143 216.755V313.468L206.99 319.941V229.612L234.143 216.755Z",
    fill: "#8CAA4F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.993 244.036V319.941L144.282 334.89V268.767L206.993 244.036Z",
    fill: "#CBF07F",
    stroke: "#304602",
    strokeWidth: 1.1376,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 756.475,
    height: 374.69,
    fill: "white",
    transform: "translate(0.967773)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureIllustration);
export default __webpack_public_path__ + "static/media/structure-Illustration.be345d30b4a5b1c716dda3a602287b3b.svg";
export { ForwardRef as ReactComponent };